import { render, staticRenderFns } from "./Programacion.vue?vue&type=template&id=2d5eff59&scoped=true&"
import script from "./Programacion.vue?vue&type=script&lang=js&"
export * from "./Programacion.vue?vue&type=script&lang=js&"
import style0 from "./Programacion.vue?vue&type=style&index=0&id=2d5eff59&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5eff59",
  null
  
)

export default component.exports